import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
const MotionLink = motion(Link);
type CtaButtonProps = {
  to?: string;
  href?: string;
  as?: 'link' | 'a' | 'button';
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  children?: React.ReactNode;
  variant?: 'pill' | 'ghost';
  className?: string;
  onClick?: () => void;
};
export function CtaButton({
  to = '/#contact',
  href,
  as,
  type = 'button',
  disabled = false,
  children = 'Book Free Consultation',
  variant = 'pill',
  className = '',
  onClick
}: CtaButtonProps) {
  const isPill = variant === 'pill';
  const content = <>
      {isPill ? <>
          <span className="pill__label" data-id="element-67">{children}</span>
          <span className="pill__circle relative" data-id="element-68">
            <motion.span className="absolute inset-0 flex items-center justify-center" variants={{
          initial: {
            x: 0,
            y: 0,
            opacity: 1
          },
          hover: {
            x: 26,
            y: -26,
            opacity: 0
          }
        }} transition={{
          duration: 0.4,
          ease: [0.2, 0.7, 0.2, 1]
        }} data-id="element-69">
              <ArrowRight size={16} data-id="element-70" />
            </motion.span>
            <motion.span className="absolute inset-0 flex items-center justify-center" variants={{
          initial: {
            x: -26,
            y: 26,
            opacity: 0
          },
          hover: {
            x: 0,
            y: 0,
            opacity: 1
          }
        }} transition={{
          duration: 0.4,
          ease: [0.2, 0.7, 0.2, 1]
        }} data-id="element-71">
              <ArrowRight size={16} data-id="element-72" />
            </motion.span>
          </span>
        </> : children}
    </>;
  const baseClasses = isPill ? 'pill' : 'ghost';
  const combinedClasses = `${baseClasses} ${className} ${disabled ? 'opacity-70 cursor-not-allowed' : ''}`;
  const motionProps = {
    initial: 'initial' as const,
    whileHover: disabled ? 'initial' as const : 'hover' as const,
    whileTap: disabled ? {} : {
      scale: 0.98
    },
    transition: {
      type: 'spring' as const,
      stiffness: 420,
      damping: 26
    }
  };
  if (as === 'button') {
    return <motion.button type={type} disabled={disabled} className={combinedClasses} onClick={onClick} {...motionProps} data-id="element-73">
        {content}
      </motion.button>;
  }
  if (href || as === 'a') {
    return <motion.a href={href} className={combinedClasses} onClick={onClick} {...motionProps} data-id="element-74">
        {content}
      </motion.a>;
  }
  return <MotionLink to={to} className={combinedClasses} onClick={onClick} {...motionProps} data-id="element-75">
      {content}
    </MotionLink>;
}